const countries = [
 {
    "countryCode": "es",
    "countryLabel": "España",
    "cityCodes": [
      "Álava",
      "Albacete",
      "Alicante",
      "Almería",
      "Asturias",
      "Ávila",
      "Badajoz",
      "Barcelona",
      "Burgos",
      "Cáceres",
      "Cádiz",
      "Cantabria",
      "Castellón",
      "Ciudad Real",
      "Córdoba",
      "A Coruña",
      "Cuenca",
      "Girona",
      "Granada",
      "Guadalajara",
      "Guipúzcoa",
      "Huelva",
      "Huesca",
      "Illes Balears",
      "Jaén",
      "León",
      "Lleida",
      "Lugo",
      "Madrid",
      "Málaga",
      "Murcia",
      "Navarra",
      "Ourense",
      "Palencia",
      "Las Palmas",
      "Pontevedra",
      "La Rioja",
      "Salamanca",
      "Segovia",
      "Sevilla",
      "Soria",
      "Tarragona",
      "Santa Cruz de Tenerife",
      "Teruel",
      "Toledo",
      "Valencia",
      "Valladolid",
      "Vizcaya",
      "Zamora",
      "Zaragoza",
      "Ceuta",
      "Melilla"
    ]
  },
  {
    "countryCode": "fr",
    "countryLabel": "France",
    "cityCodes": [
      "Albi",
      "Agen",
      "Aix-en-Provence",
      "Ajaccio",
      "Alençon",
      "Amiens",
      "Angers",
      "Angoulême",
      "Annecy",
      "Arras",
      "Aurillac",
      "Auxerre",
      "Avignon",
      "Bar-le-Duc",
      "Bastia",
      "Bayonne",
      "Beauvais",
      "Belfort",
      "Besançon",
      "Blois",
      "Bobigny",
      "Bordeaux",
      "Bourg-en-Bresse",
      "Bourges",
      "Brest",
      "Brive-la-Gaillarde",
      "Caen",
      "Cahors",
      "Carcassonne",
      "Châlons-en-Champagne",
      "Chambéry",
      "Charleville-Mézières",
      "Chartres",
      "Châteauroux",
      "Chaumont",
      "Clermont-Ferrand",
      "Colmar",
      "Créteil",
      "Dijon",
      "Digne-les-Bains",
      "Dieppe",
      "Draguignan",
      "Épinal",
      "Évreux",
      "Foix",
      "Forbach",
      "Fort-de-France",
      "Gap",
      "Grenoble",
      "Guéret",
      "Laon",
      "Le Havre",
      "Le Mans",
      "Le Puy-en-Velay",
      "Lille",
      "Limoges",
      "Lons-le-Saunier",
      "Lorient",
      "Lyon",
      "Mâcon",
      "Marseille",
      "Melun",
      "Metz",
      "Montauban",
      "Mont-de-Marsan",
      "Montpellier",
      "Moulins",
      "Nancy",
      "Nanterre",
      "Nantes",
      "Narbonne",
      "Nevers",
      "Nice",
      "Nîmes",
      "Niort",
      "Orléans",
      "Pamiers",
      "Paris",
      "Pau",
      "Perpignan",
      "Périgueux",
      "Poitiers",
      "Privas",
      "Quimper",
      "Reims",
      "Rennes",
      "Rodez",
      "Rouen",
      "Saint-Brieuc",
      "Saint-Denis",
      "Saint-Étienne",
      "Saint-Lô",
      "Saint-Quentin",
      "Sarlat-la-Canéda",
      "Strasbourg",
      "Tarbes",
      "Toulon",
      "Toulouse",
      "Tours",
      "Troyes",
      "Valence",
      "Vannes",
      "Versailles",
      "Vesoul",
      "Vichy",
      "Vienne",
      "Villefranche-sur-Saône"
    ]
  },
  {
    "countryCode": "de",
    "countryLabel": "Deutschland",
    "cityCodes": [
      "Aachen",
      "Augsburg",
      "Berlin",
      "Bielefeld",
      "Bochum",
      "Bonn",
      "Bremen",
      "Chemnitz",
      "Dortmund",
      "Dresden",
      "Duisburg",
      "Düsseldorf",
      "Erfurt",
      "Essen",
      "Frankfurt am Main",
      "Freiburg im Breisgau",
      "Gelsenkirchen",
      "Hamburg",
      "Hannover",
      "Heidelberg",
      "Heilbronn",
      "Ingolstadt",
      "Karlsruhe",
      "Kassel",
      "Kiel",
      "Köln",
      "Leipzig",
      "Lübeck",
      "Magdeburg",
      "Mainz",
      "Mannheim",
      "München",
      "Münster",
      "Nürnberg",
      "Oldenburg",
      "Osnabrück",
      "Potsdam",
      "Regensburg",
      "Rostock",
      "Saarbrücken",
      "Schwerin",
      "Stuttgart",
      "Trier",
      "Ulm",
      "Wiesbaden",
      "Wolfsburg",
      "Wuppertal",
      "Zwickau"
    ]
  },
  {
    "countryCode": "it",
    "countryLabel": "Italia",
    "cityCodes": [
      "Agrigento",
      "Ancona",
      "Aosta",
      "Arezzo",
      "Ascoli Piceno",
      "Bari",
      "Belluno",
      "Benevento",
      "Bergamo",
      "Biella",
      "Bologna",
      "Bolzano",
      "Brescia",
      "Brindisi",
      "Cagliari",
      "Caltanissetta",
      "Campobasso",
      "Caserta",
      "Catania",
      "Catanzaro",
      "Chieti",
      "Como",
      "Cosenza",
      "Cremona",
      "Crotone",
      "Cuneo",
      "Enna",
      "Fermo",
      "Ferrara",
      "Firenze",
      "Foggia",
      "Forlì",
      "Frosinone",
      "Genova",
      "Gorizia",
      "Grosseto",
      "Imperia",
      "Isernia",
      "L'Aquila",
      "La Spezia",
      "Latina",
      "Lecce",
      "Lecco",
      "Livorno",
      "Lodi",
      "Lucca",
      "Macerata",
      "Mantova",
      "Massa",
      "Matera",
      "Messina",
      "Milano",
      "Modena",
      "Monza",
      "Napoli",
      "Novara",
      "Nuoro",
      "Oristano",
      "Padova",
      "Palermo",
      "Parma",
      "Pavia",
      "Perugia",
      "Pesaro",
      "Pescara",
      "Piacenza",
      "Pisa",
      "Pistoia",
      "Pordenone",
      "Potenza",
      "Prato",
      "Ragusa",
      "Ravenna",
      "Reggio Calabria",
      "Reggio Emilia",
      "Rieti",
      "Rimini",
      "Roma",
      "Rovigo",
      "Salerno",
      "Sassari",
      "Savona",
      "Siena",
      "Siracusa",
      "Sondrio",
      "Taranto",
      "Teramo",
      "Terni",
      "Torino",
      "Trapani",
      "Trento",
      "Treviso",
      "Trieste",
      "Udine",
      "Varese",
      "Venezia",
      "Verbania",
      "Vercelli",
      "Verona",
      "Vibo Valentia",
      "Vicenza",
      "Viterbo"
    ]
  },
  {
    "countryCode": "pl",
    "countryLabel": "Polska",
    "cityCodes": [
      "Biała Podlaska",
      "Białystok",
      "Bielsko-Biała",
      "Bydgoszcz",
      "Bytom",
      "Chełm",
      "Chorzów",
      "Częstochowa",
      "Dąbrowa Górnicza",
      "Elbląg",
      "Gdańsk",
      "Gdynia",
      "Gliwice",
      "Gorzów Wielkopolski",
      "Grudziądz",
      "Jastrzębie-Zdrój",
      "Jaworzno",
      "Jelenia Góra",
      "Kalisz",
      "Katowice",
      "Kielce",
      "Konin",
      "Koszalin",
      "Kraków",
      "Krosno",
      "Legnica",
      "Leszno",
      "Lublin",
      "Łomża",
      "Łódź",
      "Mysłowice",
      "Nowy Sącz",
      "Olsztyn",
      "Opole",
      "Ostrołęka",
      "Piekary Śląskie",
      "Piotrków Trybunalski",
      "Płock",
      "Poznań",
      "Przemyśl",
      "Radom",
      "Ruda Śląska",
      "Rybnik",
      "Rzeszów",
      "Siedlce",
      "Siemianowice Śląskie",
      "Skierniewice",
      "Słupsk",
      "Sopot",
      "Sosnowiec",
      "Suwałki",
      "Szczecin",
      "Świętochłowice",
      "Świnoujście",
      "Tarnobrzeg",
      "Tarnów",
      "Toruń",
      "Tychy",
      "Wałbrzych",
      "Warszawa",
      "Włocławek",
      "Wrocław",
      "Zabrze",
      "Zamość",
      "Zielona Góra",
      "Żory"
    ]
  },
    {
    "countryCode": "cy",
    "countryLabel": "Κύπρος",
    "cityCodes": [
        "Λευκωσία",
        "Λεμεσός",
        "Λάρνακα",
        "Στρόβολος",
        "Λακατάμια",
        "Πάφος",
        "Αραδίππου",
        "Κάτω Πολεμίδια",
        "Άγιος Αθανάσιος",
        "Έγκωμη",
        "Λατσιά",
        "Γερμασόγεια",
        "Αγλαντζιά",
        "Γέρι",
        "Δάλι",
        "Τσέρι",
        "Λιβάδια",
        "Γεροσκήπου",
        "Παραλίμνι",
        "Πέγεια",
        "Σωτήρα",
        "Δερύνεια",
        "Άγιος Δομέτιος",
        "Δρομολαξιά-Μενεού",
        "Χλώρακας",
        "Κολόσσι",
        "Κίτι",
        "Κοκκινοτριμιθιά",
        "Λιοπέτρι",
        "Αθηένου"
    ]
  },
  {
    "countryCode": "gr",
    "countryLabel": "Ελλάδα",
    "cityCodes": [
      "Αθήνα",
      "Θεσσαλονίκη",
      "Πάτρα",
      "Ηράκλειο",
      "Λάρισα",
      "Βόλος",
      "Ιωάννινα",
      "Τρίπολη",
      "Κέρκυρα",
      "Χανιά",
      "Καβάλα",
      "Καλαμάτα",
      "Κατερίνη",
      "Κομοτηνή",
      "Σέρρες",
      "Ξάνθη",
      "Ρόδος",
      "Λαμία",
      "Καρδίτσα",
      "Αγρίνιο",
      "Χαλκίδα",
      "Σπάρτη",
      "Κοζάνη",
      "Δράμα",
      "Καρπενήσι",
      "Λευκάδα",
      "Πρέβεζα",
      "Άρτα",
      "Φλώρινα",
      "Γρεβενά",
      "Ναύπλιο",
      "Καστοριά",
      "Πύργος",
      "Κιλκίς",
      "Άγιος Νικόλαος",
      "Ρέθυμνο",
      "Σάμος",
      "Λέσβος",
      "Χίος",
      "Σύρος",
      "Νάξος",
      "Άνδρος",
      "Κάλυμνος",
      "Κως",
      "Λήμνος",
      "Ικαρία",
      "Σκιάθος",
      "Θήβα",
      "Λιβαδειά",
      "Αλεξανδρούπολη",
      "Ορεστιάδα",
      "Καρπενήσι",
      "Αμαλιάδα",
      "Ζάκυνθος",
      "Αργοστόλι",
      "Λευκάδα",
      "Σάμη",
      "Πόρος",
      "Σύβοτα",
      "Πάργα",
      "Ιθάκη",
      "Κύθηρα",
      "Σαντορίνη",
      "Μύκονος",
      "Πάρος",
      "Νάουσα",
      "Σίφνος",
      "Σέριφος",
      "Μήλος",
      "Κέα",
      "Κύθνος",
      "Ανάφη",
      "Αστυπάλαια",
      "Πάτμος",
      "Λέρος",
      "Κάρπαθος",
      "Κάσος",
      "Σύμη",
      "Τήλος",
      "Χάλκη",
      "Νίσυρος",
      "Καστελλόριζο",
      "Αμοργός",
      "Φολέγανδρος",
      "Κουφονήσια",
      "Σχοινούσα",
      "Ηρακλειά",
      "Δονούσα",
      "Αντίπαρος",
      "Κίμωλος",
      "Σίκινος",
      "Θηρασιά",
      "Ανάφη",
      "Μακρονήσι",
      "Σαλαμίνα",
      "Αίγινα",
      "Πόρος",
      "Ύδρα",
      "Σπέτσες",
      "Κύθηρα",
      "Αντικύθηρα",
      "Γαύδος"
    ]
  },
  {
    "countryCode": "hr",
    "countryLabel": "Hrvatska",
    "cityCodes": [
      "Bjelovar",
      "Slavonski Brod",
      "Dubrovnik",
      "Pazin",
      "Karlovac",
      "Koprivnica",
      "Krapina",
      "Gospić",
      "Čakovec",
      "Osijek",
      "Požega",
      "Rijeka",
      "Šibenik",
      "Sisak",
      "Split",
      "Varaždin",
      "Virovitica",
      "Vukovar",
      "Zadar",
      "Zagreb",
      "Zagreb"
    ]
  },
  {
    "countryCode": "hu",
    "countryLabel": "Magyarország",
    "cityCodes": [
      "Budapest",
      "Debrecen",
      "Szeged",
      "Miskolc",
      "Pécs",
      "Győr",
      "Nyíregyháza",
      "Kecskemét",
      "Székesfehérvár",
      "Szombathely",
      "Szolnok",
      "Tatabánya",
      "Kaposvár",
      "Érd",
      "Veszprém",
      "Békéscsaba",
      "Zalaegerszeg",
      "Eger",
      "Nagykanizsa",
      "Dunaújváros"
    ]
  },
  {
    "countryCode": "ie",
    "countryLabel": "Ireland",
    "cityCodes": [
      "Dublin",
      "Cork",
      "Limerick",
      "Galway",
      "Waterford",
      "Drogheda",
      "Dundalk",
      "Swords",
      "Bray",
      "Navan",
      "Ennis",
      "Carlow",
      "Kilkenny",
      "Naas",
      "Tralee",
      "Newbridge",
      "Balbriggan",
      "Portlaoise",
      "Athlone",
      "Mullingar"
    ]
  },
  {
    "countryCode": "lt",
    "countryLabel": "Lietuva",
    "cityCodes": [
      "Vilnius",
      "Kaunas",
      "Klaipėda",
      "Šiauliai",
      "Panevėžys",
      "Alytus",
      "Marijampolė",
      "Mažeikiai",
      "Jonava",
      "Utena",
      "Kėdainiai",
      "Telšiai",
      "Tauragė",
      "Ukmergė",
      "Visaginas",
      "Radviliškis",
      "Plungė",
      "Kretinga",
      "Palanga",
      "Druskininkai"
    ]
  },
  {
    "countryCode": "lu",
    "countryLabel": "Lëtzebuerg",
    "cityCodes": [
      "Lëtzebuerg",
      "Esch-Uelzecht",
      "Diddeleng",
      "Déifferdeng",
      "Péiteng",
      "Sanem",
      "Schëffleng",
      "Bettenduerf",
      "Ettelbréck",
      "Stroossen",
      "Bartreng",
      "Hesper",
      "Mamer",
      "Steesel",
      "Käerjeng",
      "Remich",
      "Bertrange",
      "Walferdange",
      "Mondorf-les-Bains",
      "Grevenmacher"
    ]
  },
  {
    "countryCode": "lv",
    "countryLabel": "Latvija",
    "cityCodes": [
      "Rīga",
      "Daugavpils",
      "Liepāja",
      "Jelgava",
      "Jūrmala",
      "Ventspils",
      "Rēzekne",
      "Valmiera",
      "Ogre",
      "Jēkabpils",
      "Tukums",
      "Cēsis",
      "Salaspils",
      "Kuldīga",
      "Saldus",
      "Sigulda",
      "Bauska",
      "Talsi",
      "Dobele",
      "Smiltene"
    ]
  },
  {
    "countryCode": "mt",
    "countryLabel": "Malta",
    "cityCodes": [
      "Il-Belt Valletta",
      "Birkirkara",
      "Mosta",
      "Qormi",
      "Sliema",
      "San Pawl il-Baħar",
      "Żabbar",
      "Żebbuġ",
      "Fgura",
      "Naxxar",
      "Ħamrun",
      "Marsaskala",
      "Siġġiewi",
      "Rabat",
      "Żejtun",
      "Birżebbuġa",
      "San Ġwann",
      "Ħaż-Żabbar",
      "Ħaż-Żebbuġ",
      "Mellieħa"
    ]
  },
  {
    "countryCode": "nl",
    "countryLabel": "Nederland",
    "cityCodes": [
      "Amsterdam",
      "Rotterdam",
      "Den Haag",
      "Utrecht",
      "Eindhoven",
      "Tilburg",
      "Groningen",
      "Almere",
      "Breda",
      "Nijmegen",
      "Enschede",
      "Haarlem",
      "Arnhem",
      "Zaanstad",
      "Amersfoort",
      "Apeldoorn",
      "'s-Hertogenbosch",
      "Hoofddorp",
      "Maastricht",
      "Leiden",
      "Middelburg",
        "Leeuwarden",
      "Assen",
      "Zwolle",
      "Lelystad"
    ]
  },
  {
    "countryCode": "pt",
    "countryLabel": "Portugal",
    "cityCodes": [
      "Lisboa",
      "Porto",
      "Vila Nova de Gaia",
      "Amadora",
      "Braga",
      "Coimbra",
      "Funchal",
      "Setúbal",
      "Almada",
      "Agualva-Cacém",
      "Queluz",
      "Oeiras",
      "Aveiro",
      "Leiria",
      "Barreiro",
      "Ponta Delgada",
      "Viseu",
      "Guimarães",
      "Évora",
      "Faro"
    ]
  },
  {
    "countryCode": "ro",
    "countryLabel": "România",
    "cityCodes": [
        "Alba Iulia",
        "Arad",
        "Pitești",
        "Bacău",
        "Oradea",
        "Bistrița",
        "Botoșani",
        "Brașov",
        "Brăila",
        "Buzău",
        "Călărași",
        "Cluj-Napoca",
        "Constanța",
        "Sfântu Gheorghe",
        "Târgoviște",
        "Craiova",
        "Galați",
        "Giurgiu",
        "Târgu Jiu",
        "Miercurea Ciuc",
        "Deva",
        "Iași",
        "Ilfov",
        "Baia Mare",
        "Drobeta-Turnu Severin",
        "Târgu Mureș",
        "Piatra Neamț",
        "Slatina",
        "Ploiești",
        "Satu Mare",
        "Săcele",
        "Sibiu",
        "Suceava",
        "Alexandria",
        "Timișoara",
        "Tulcea",
        "Vaslui",
        "Râmnicu Vâlcea",
        "Focșani",
        "Bârlad",
        "Zalău",
        "București"
    ]
  },
  {
    "countryCode": "sk",
    "countryLabel": "Slovensko",
    "cityCodes": [
      "Bratislava",
      "Košice",
      "Prešov",
      "Žilina",
      "Nitra",
      "Banská Bystrica",
      "Trnava",
      "Trenčín",
      "Martin",
      "Poprad",
      "Prievidza",
      "Zvolen",
      "Považská Bystrica",
      "Michalovce",
      "Nové Zámky",
      "Spišská Nová Ves",
      "Komárno",
      "Levice",
      "Lučenec",
      "Piešťany"
    ]
  },
  {
    "countryCode": "si",
    "countryLabel": "Slovenija",
    "cityCodes": [
      "Ljubljana",
      "Maribor",
      "Celje",
      "Kranj",
      "Velenje",
      "Koper",
      "Novo Mesto",
      "Ptuj",
      "Trbovlje",
      "Kamnik",
      "Nova Gorica",
      "Murska Sobota",
      "Jesenice",
      "Domžale",
      "Izola",
      "Škofja Loka",
      "Sežana",
      "Postojna",
      "Logatec",
      "Ravne na Koroškem"
    ]
  },
  {
    "countryCode": "fi",
    "countryLabel": "Suomi",
    "cityCodes": [
        "Helsinki",
        "Turku",
        "Tampere",
        "Lahti",
        "Lappeenranta",
        "Jyväskylä",
        "Kuopio",
        "Joensuu",
        "Vaasa",
        "Oulu",
        "Rovaniemi",
        "Kokkola",
        "Seinäjoki",
        "Mariehamn",
        "Mikkeli",
        "Porvoo",
        "Hyvinkää",
        "Hämeenlinna",
        "Savonlinna"
    ]
  },
  {
    "countryCode": "se",
    "countryLabel": "Sverige",
    "cityCodes": [
      "Stockholm",
      "Göteborg",
      "Malmö",
      "Uppsala",
      "Västerås",
      "Örebro",
      "Linköping",
      "Helsingborg",
      "Jönköping",
      "Norrköping",
      "Lund",
      "Umeå",
      "Gävle",
      "Borås",
      "Eskilstuna",
      "Södertälje",
      "Karlstad",
      "Täby",
      "Växjö",
      "Halmstad"
    ]
  },
  {
    "countryCode": "cz",
    "countryLabel": "Česko",
    "cityCodes": [
      "Praha",
      "Brno",
      "Ostrava",
      "Plzeň",
      "Liberec",
      "Olomouc",
      "České Budějovice",
      "Hradec Králové",
      "Pardubice",
      "Ústí nad Labem",
      "Zlín",
      "Kladno",
      "Havířov",
      "Most",
      "Opava",
      "Jihlava",
      "Frýdek-Místek",
      "Teplice",
      "Karlovy Vary",
      "Karviná"
    ]
  },
  {
    "countryCode": "dk",
    "countryLabel": "Danmark",
    "cityCodes": [
      "København",
      "Aarhus",
      "Odense",
      "Aalborg",
      "Esbjerg",
      "Randers",
      "Kolding",
      "Horsens",
      "Vejle",
      "Roskilde",
      "Herning",
      "Hørsholm",
      "Helsingør",
      "Silkeborg",
      "Næstved",
      "Fredericia",
      "Viborg",
      "Holstebro",
      "Taastrup",
      "Slagelse"
    ]
  },
  {
    "countryCode": "ee",
    "countryLabel": "Eesti",
    "cityCodes": [
      "Tallinn",
      "Tartu",
      "Narva",
      "Kohtla-Järve",
      "Pärnu",
      "Viljandi",
      "Rakvere",
      "Maardu",
      "Kuressaare",
      "Sillamäe",
      "Valga",
      "Võru",
      "Jõhvi",
      "Haapsalu",
      "Keila",
      "Paide",
      "Elva",
      "Saue",
      "Tapa",
      "Põlva"
    ]
  },
  {
    "countryCode": "at",
    "countryLabel": "Österreich",
    "cityCodes": [
      "Wien",
      "Graz",
      "Linz",
      "Salzburg",
      "Innsbruck",
      "Klagenfurt am Wörthersee",
      "Villach",
      "Wels",
      "Sankt Pölten",
      "Dornbirn",
      "Wiener Neustadt",
      "Steyr",
      "Feldkirch",
      "Bregenz",
      "Leonding",
      "Klosterneuburg",
      "Baden bei Wien",
      "Leoben",
      "Wolfsberg",
      "Traun"
    ]
  },
  {
    "countryCode": "be",
    "countryLabel": "België",
    "cityCodes": [
      "Brussel",
      "Antwerpen",
      "Gent",
      "Charleroi",
      "Luik",
      "Brugge",
      "Namen",
      "Leuven",
      "Mons",
      "Aalst",
      "Mechelen",
      "La Louvière",
      "Kortrijk",
      "Hasselt",
      "Sint-Niklaas",
      "Oostende",
      "Tournai",
      "Genk",
      "Seraing",
      "Roeselare"
    ]
  },
  {
    "countryCode": "bg",
    "countryLabel": "България",
    "cityCodes": [
        "Благоевград",
        "Бургас",
        "Варна",
        "Велико Търново",
        "Видин",
        "Враца",
        "Габрово",
        "Добрич",
        "Кърджали",
        "Кюстендил",
        "Ловеч",
        "Монтана",
        "Пазарджик",
        "Перник",
        "Плевен",
        "Пловдив",
        "Разград",
        "Русе",
        "Силистра",
        "Сливен",
        "Смолян",
        "София",
        "София",
        "Стара Загора",
        "Търговище",
        "Хасково",
        "Шумен",
        "Ямбол"
    ]
  }

];

export default countries;
